import { Injectable } from "@angular/core";
import { datadogRum } from "@datadog/browser-rum";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class DataDogService {
  initDataDog(): void {
    if (environment.DATA_DOG_ID) {
      datadogRum.init({
        applicationId: "258b973a-bbd1-4ad9-98f8-b630d5798747",
        clientToken: environment.DATA_DOG_ID,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: "datadoghq.com",
        service: "lmn-swa-pro-web-customer-portal",
        env: environment.DATA_DOG_ENV,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: environment.DATA_DOG_VERSION,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackBfcacheViews: true,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: "mask-user-input",
        trackViewsManually: false,
        allowedTracingUrls: [
          /http:\/\/localhost:.*/,
          /http:\/\/.*\.golmn\.com/,
          /https:\/\/.*\.golmn\.com/,
          /https:\/\/.*groundsguyspro\.com/,
        ],
      });
    }
  }
}

